import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import DataTableDemandeAdministrative from "./DataTableDemandeAdministrative";
import AddDemandeAdministrative from "./AddDemandeAdministrative";
import DataTableDemandeAdministrativeEnseignant from "./DataTableDemandeAdministrativeEnseignant";
import AddDemandeAdministrativeEnseignant from "./AddDemandeAdministrativeEnseignant";

const DemandeAdministrative = props => {
  const [section, setSection] = useState(1)
  const [add, setAdd] = useState(0);
  useEffect(async () => {
    const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    const typeArticleSubMenu = userAuth.find(user =>
        user.sous_menu.some(subMenu => subMenu.sous_menu === "Demande vierge Enseignant")
    );
    setAdd(typeArticleSubMenu.sous_menu[0].add)
  }, [])
  const back = () => {
    setSection(1)
  }

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableDemandeAdministrative />
    } else if (section === 2) {
      return <AddDemandeAdministrative setSection={setSection} back={back} />
    }else if (section === 3){
      return <DataTableDemandeAdministrativeEnseignant setSection={setSection} back={back} />
    }else if (section === 4){
      return <AddDemandeAdministrativeEnseignant setSection={setSection} back={back} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Demande Administrative")} | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Document vierge administrative")}
                </NavLink>
              </NavItem>
              {add === 1 ? (
                  <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: section === 2,
                        })}
                        onClick={() => {
                          setSection(2)
                        }}
                    >
                      {props.t("Ajouter")} {props.t("Document vierge administrative")}
                    </NavLink>
                  </NavItem>
              ):(null)}

              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 3,
                  })}
                  onClick={() => {
                    setSection(3)
                  }}
                >
                  {props.t("Document vierge administrative enseignant")}
                </NavLink>
              </NavItem>
              {add === 1 ? (
                  <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: section === 4,
                        })}
                        onClick={() => {
                          setSection(4)
                        }}
                    >
                      {props.t("Ajouter")} {props.t("Document vierge administrative enseignant")}
                    </NavLink>
                  </NavItem>
              ):(null)}
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DemandeAdministrative))
DemandeAdministrative.propTypes = {
  t: PropTypes.any,
}
